import { render, staticRenderFns } from "./detalleCliente.vue?vue&type=template&id=79ac1014"
import script from "./detalleCliente.vue?vue&type=script&lang=js"
export * from "./detalleCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports